export default "__VITE_ASSET__DAgIsGN4__"